import { SubscriptionTier } from '@upright/common/activities/contact-forms/company-subscription/subscription-tiers';
import { E2eTestElementId } from '@upright/test-ids/dom-elements';
import { FormModalContent, FormModalTopBar } from '@upright/ui/common/generic/modals/form-modal/form-modal-parts';
import { useSubscriptionContext } from '../../context';
import { SubscriptionModalBottomBar } from '../../subscription-modal-bottom-bar';
import { CompanyNameInput, EmailInput, FirstNameInput, LastNameInput, PasswordInput } from '../inputs/text-inputs';
import { FreeTierSuccessPage } from './success-page';

export const FreeTierSubscriptionPage = () => {
  const context = useSubscriptionContext();
  const [params] = context.params;
  const success = !!params.success;

  const [submitButtonClicked] = context.submitButtonClicked;

  if (success) {
    return <FreeTierSuccessPage />;
  }

  return (
    <>
      <FormModalTopBar>
        <h1>Update your input data for free</h1>
      </FormModalTopBar>
      <FormModalContent>
        <div className={'subscriptionForm'}>
          <section>
            <p>
              The Upright model is based on the company's core business: the products and services it produces. Make
              sure your company has an up-to-date, high-quality profile by updating your input data on the Upright
              Platform.
            </p>
            <p>
              After you create a free account, you can start entering the products/services of your company right away.
              If you want to get the right to use your impact data in any external or internal use case,{' '}
              <span
                id="contactLink"
                onClick={() => {
                  context.setTier(SubscriptionTier.STANDARD);
                }}
              >
                book a demo
              </span>{' '}
              with us.
            </p>
          </section>
          <section id={'inputs'}>
            <FirstNameInput {...{ submitButtonClicked, id: E2eTestElementId.SELF_SIGNUP_FIRST_NAME }} />
            <LastNameInput {...{ submitButtonClicked, id: E2eTestElementId.SELF_SIGNUP_LAST_NAME }} />
            <CompanyNameInput {...{ submitButtonClicked, id: E2eTestElementId.SELF_SIGNUP_COMPANY_NAME }} />
            <EmailInput {...{ submitButtonClicked, id: E2eTestElementId.SELF_SIGNUP_EMAIL }} />
            <PasswordInput {...{ submitButtonClicked, id: E2eTestElementId.SELF_SIGNUP_PASSWORD }} />
          </section>
          {context.submitQuery.isError && (
            <section>
              <div className="subscriptionError">{context.submitQuery.error?.message}</div>
            </section>
          )}
        </div>
      </FormModalContent>
      <SubscriptionModalBottomBar />
    </>
  );
};
